import services from '@/config/services'

export default class RecuperoCreditoService{
  
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
    this.baseUrlPratiche = `${services.ask_pratiche.url}`
  }


    async getDettaglioContatto(id, params) {
      try {
        const response = await this.http.get(`${this.baseUrlPratiche}/recupero-credito/contatto/${id}`, {
          params
        });
        return response.data;
      } catch (error) {
        console.error('Errore nella chiamata getDettaglioContatto:', error);
        throw error;
      }
    }

  async getUserTickets(userId, userType = 'client', limit = 50) {
    try {
      const response = await this.http.get(`${this.baseUrlPratiche}/recupero-credito/user/tickets`, {
        params: {
          user_id: userId,
          user_type: userType,
          limit
        }
      });
      return response.data;
    } catch (error) {
      console.error('Errore nella chiamata getUserTickets:', error);
      throw error;
    }
  }

  async getTicketRecipients(string, type){
    let items = {}
    const url = `${this.baseUrlPratiche}/recupero-credito/ticket/recipients`

    try {
        let res = await this.http.post(url, {string, type})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getTypesEntity(){
    const url = `${this.baseUrlPratiche}/recupero-credito/types/entity`
    try {
      const res = await this.http.get(url)
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getTicketEntity(string, type, { limit = 10, offset = 0, id_field = 'id', min_length = 2, filters = {} } = {}){
    const url = `${this.baseUrlPratiche}/recupero-credito/ticket/entity`
    try {
      const payload = { string, type, limit, offset, id_field, min_length, filters }
      const res = await this.http.post(url, payload)
      const data = res.data || {}
      return {
        items: Array.isArray(data.data) ? data.data : [],
        total: Number(data.total || 0),
        has_more: Boolean(data.has_more),
        limit: Number(data.limit || limit),
        offset: Number(data.offset || offset),
        min_length: Number(data.min_length || min_length)
      }
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async createTicket(ticketData) {
    try {
      const response = await this.http.post(
        `${this.baseUrlPratiche}/recupero-credito/ticket/create`,
        { ticket: ticketData }
      );
      return response.data;
    } catch (error) {
      console.error('Errore nella chiamata createTicket:', error);
      throw error;
    }
  }

  async gestisciCredito(creditoData) {
    try { 
      const response = await this.http.post(
        `${this.baseUrlPratiche}/recupero-credito/gestisci-credito`,
        creditoData
      );
            
      return response.data;
    } catch (error) {
      console.error('Errore nella chiamata gestisciCredito:', error);
      throw error;
    }
  }

  async updateGestisciCredito(codCliente, creditoData) {
    try {   
      const response = await this.http.put(
        `${this.baseUrlPratiche}/recupero-credito/gestisci-credito/${codCliente}`,
        creditoData
      );
      return response.data;
    } catch (error) {
      console.error('Errore nella chiamata updateGestisciCredito:', error);
      throw error;
    }
  }


  async getClientiCredito(params = {}) {
    try {
      const response = await this.http.get(`${this.baseUrlPratiche}/recupero-credito/get-clienti-credito`, {
        params
      });
      return response.data;
    } catch (error) {
      console.error('Errore nella chiamata getClientiCredito:', error);
      throw error;
    }
  }

  async getRappresentantiCredito(params = {}) {
    try {
      const response = await this.http.get(`${this.baseUrlPratiche}/recupero-credito/get-rappresentanti-credito`, {
        params
      });
      return response.data;
    } catch (error) {
      console.error('Errore nella chiamata getRappresentantiCredito:', error);
      throw error;
    }
  }


  async getInfoValidazioniCredito(params = {}) {
    try {
      const response = await this.http.get(`${this.baseUrlPratiche}/recupero-credito/get-info-validazioni-credito`, {
        params
      });
      return response.data;
    } catch (error) {
      console.error('Errore nella chiamata getInfoValidazioniCredito:', error);
      throw error;
    }
  }

  async getCreditoDaGestire(params = {}) {
    try {
      const response = await this.http.get(
        `${this.baseUrlPratiche}/recupero-credito/get-credito-da-gestire`,
        { params }
      );
      return response.data;
    } catch (error) {
      console.error('Errore nella chiamata getCreditoDaGestire:', error);
      throw error;
    }
  }

  async getAgentiFirmatari(agenteMasterId, params = {}) {
    try {
      const response = await this.http.get(
        `${this.baseUrlPratiche}/recupero-credito/get-agenti-firmatari`,
        { 
          params: {
            agente_master_id: agenteMasterId,
            ...params
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Errore nella chiamata getAgentiFirmatari:', error);
      throw error;
    }
  }

  async getRappresentanti(agenteFirmatarioId, params = {}) {
    try {
      const response = await this.http.get(
        `${this.baseUrlPratiche}/recupero-credito/get-rappresentanti`,
        { 
          params: {
            agente_firmatario_id: agenteFirmatarioId,
            limit: params.limit ?? 50,
            offset: params.offset ?? 0,
            ...params
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Errore nella chiamata getRappresentanti:', error);
      throw error;
    }
  }

  async getClienti(rappresentanteId, params = {}) {
    try {
      const requestParams = {
        rappresentante_id: rappresentanteId,
        limit: params.limit ?? 50,
        offset: params.offset ?? 0,
        ...params
      };
      if (params.agente_firmatario_id != null) {
        requestParams.agente_firmatario_id = params.agente_firmatario_id;
      }
      const response = await this.http.get(
        `${this.baseUrlPratiche}/recupero-credito/get-clienti`,
        { params: requestParams }
      );
      return response.data;
    } catch (error) {
      console.error('Errore nella chiamata getClienti:', error);
      throw error;
    }
  }

  async getClientiByFirmatario(agenteFirmatarioId, params = {}) {
    return this.getClienti(0, {
      agente_firmatario_id: agenteFirmatarioId,
      limit: params.limit ?? 50,
      offset: params.offset ?? 0,
      ...params
    });
  }

  async getInfoClienteVoltura(params = {}) {
    try {
      const response = await this.http.get(
        `${this.baseUrlPratiche}/recupero-credito/get-info-cliente-voltura`,
        { 
          params: {
            cod_pod: params.cod_pod,
            cod_pdr: params.cod_pdr
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Errore nella chiamata getInfoClienteVoltura:', error);
      throw error;
    }
  }

  async checkDistacco(params = {}) {
    try {
      const response = await this.http.get(
        `${this.baseUrlPratiche}/recupero-credito/check-distacco`,
        {
          params: {
            cod_pod: params.cod_pod,
            cod_pdr: params.cod_pdr
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Errore nella chiamata checkDistacco:', error);
      throw error;
    }
  }

  async inviaEmailBonaria(numeriFattura) {
    try {
      const url = `${services.ask_pratiche_base.url}/api/mail-sender/proforma-sollecito-privilegiati`;
      const response = await this.http.post(url, {
        numeri_fattura: numeriFattura
      });
      return response.data;
    } catch (error) {
      console.error('Errore nella chiamata inviaEmailBonaria:', error);
      throw error;
    }
  }


}
